// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2_iEB","select":"Header_select__2VAfD","clinic":"Header_clinic__p9r0Y"};